import { FT, Spine } from 'ft'

const $SPINE = 'spine.SC05_Guest'
FT.rm.addSpine($SPINE)

class BG1 extends Spine {
  constructor(friendCount) {
    super(FT.rm.spine($SPINE))
    this.scale.set(0.5)
    this.position.set(FT.stage.centerX, FT.stage.centerY)

    this.render(friendCount)
  }

  render(friendCount) {
    const slot = 'SC05/G_01'

    if (friendCount < 1) {
      this.skeleton.setAttachment(slot, null)
    } else {
      this.skeleton.setAttachment(slot, slot)
    }
  }
}

export default BG1
